import { useEffect, useMemo, useState } from 'react';

import { DASHBOARD_PAGE_SIZE } from '../constants';

const useDashboardPagination = (rows, pageSize = DASHBOARD_PAGE_SIZE) => {
  const [page, setPage] = useState(1);
  const total = rows?.length || 0;
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const visibleRows = useMemo(() => {
    const start = (page - 1) * pageSize;
    return (rows || []).slice(start, start + pageSize);
  }, [page, pageSize, rows]);

  useEffect(() => {
    if (page > pageCount) setPage(pageCount);
  }, [page, pageCount]);

  return {
    page,
    setPage,
    pageCount,
    visibleRows,
    from: total ? (page - 1) * pageSize + 1 : 0,
    to: total ? Math.min(page * pageSize, total) : 0,
    total,
    pageSize,
    resetPage: () => setPage(1),
  };
};

export default useDashboardPagination;
